var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex items-center break-words" },
    [
      _vm.icon
        ? _c("svg-icon", {
            staticClass: "icon-2xl me-2",
            attrs: { name: _vm.icon },
          })
        : _vm._e(),
      _c("div", { class: _vm.valueClasses }, [_vm._v(_vm._s(_vm.localValue))]),
      _vm.tooltip
        ? _c("svg-icon", {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip.bottom",
                value: _vm.tooltip,
                expression: "tooltip",
                modifiers: { bottom: true },
              },
            ],
            staticClass: "inline icon-sm -mt-1 mx-1 flex-shrink-0",
            attrs: { name: "info-circle" },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }